import { render, staticRenderFns } from "./NotAuthorizedLayout.vue?vue&type=template&id=4dbe8df2&"
import script from "./NotAuthorizedLayout.vue?vue&type=script&lang=js&"
export * from "./NotAuthorizedLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports